module.exports = __webpack_public_path__ + "img/search.8de09c6b.png";